export default "__VITE_ASSET__CQfuwDze__"